<div class="flex gap-2 pb-4">    
    <div class="input-field">
        <p-calendar [firstDayOfWeek]="1" [(ngModel)]="filters.dateFrom" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
            [yearNavigator]="true" dateFormat="dd/mm/yy" d-form-field-error appendTo="body" (onSelect)="search()"
            (onClear)="search()" placeholder="Desde"></p-calendar>
    </div>
    <div class="input-field">
        <p-calendar [firstDayOfWeek]="1" [(ngModel)]="filters.dateTo" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
            [yearNavigator]="true" dateFormat="dd/mm/yy" d-form-field-error appendTo="body" (onSelect)="search()"
            (onClear)="search()" placeholder="Hasta"></p-calendar>
    </div>
</div>

<div class="flex gap-2 pb-4">
    <p-card class="flex-1" styleClass="summary-widget h-full" [style]="{'border-top': '3px solid var(--purple-500)'}">
        <span class="text-xs uppercase text-color-secondary block mb-1">Peticiones totales</span>
        <span class="font-bold text-2xl" style="color: var(--purple-500);">{{ totalRequests }}</span>
        <small class="block mt-1 text-color-secondary">Número total de peticiones de todos los bloques</small>
    </p-card>
    <p-card class="flex-1" styleClass="summary-widget h-full" [style]="{'border-top': '3px solid var(--blue-500)'}">
        <span class="text-xs uppercase text-color-secondary block mb-1">Subtotal</span>
        <span class="font-bold text-2xl" style="color: var(--blue-500);">{{ subtotal | currency: 'EUR' }}</span>
        <small class="block mt-1 text-color-secondary">Suma de los consumos antes de impuestos</small>
    </p-card>
    <p-card class="flex-1" styleClass="summary-widget h-full" [style]="{'border-top': '3px solid var(--yellow-500)'}">
        <span class="text-xs uppercase text-color-secondary block mb-1">IVA (21%)</span>
        <span class="font-bold text-2xl" style="color: var(--yellow-500);">{{ tax | currency: 'EUR' }}</span>
        <small class="block mt-1 text-color-secondary">Impuestos aplicados sobre el subtotal</small>
    </p-card>
    <p-card class="flex-1" styleClass="summary-widget h-full" [style]="{'border-top': '3px solid var(--green-500)'}">
        <span class="text-xs uppercase text-color-secondary block mb-1">Total factura</span>
        <span class="font-bold text-2xl" style="color: var(--green-500);">{{ total | currency: 'EUR' }}</span>
        <small class="block mt-1 text-color-secondary">Importe final a facturar (subtotal + IVA)</small>
    </p-card>
</div>

<p-accordion [multiple]="true" (onOpen)="onTabChange($event)">
    <p-accordionTab>
      <ng-template pTemplate="header">      
        <div class="flex justify-between items-center w-full align-items-center">
            <div class="flex align-items-center gap-2">
                <i class="pi pi-clipboard"></i>
                <div class="flex flex-column">
                    <span>Expedientes</span>
                    <small class="text-color-secondary mt-1 font-normal">Consumo generado por la gestión de expedientes que han estado activos en el periodo</small>
                </div>
            </div>
            <div class="flex gap-2 ml-auto">
                <p-tag styleClass="tag-gray" value="{{totalRecordsCases }} recuento total"
                [ngClass]="{'flex items-center justify-center text-center': true}"/>    
                <p-tag [severity]="'success'" value="{{totalProfitCases | currency: 'EUR'}} precio total" 
                    [ngClass]="{'flex items-center justify-center text-center': true}"/>  
            </div>                      
        </div>
      </ng-template>
      <div>
        <!-- Widgets de expedientes activos y anulados -->
        <div class="flex gap-2 items-center">
            <div class="bg-green-100 text-green-800 p-2 flex align-items-center gap-2">
                <span class="font-bold text-xlg">{{ totalActiveCases }}</span>
                <span class="text-xs">Expedientes<br>activos</span>
            </div>
            <div class="bg-blue-100 text-blue-800 p-2 flex align-items-center gap-2">
                <span class="font-bold text-xlg">{{ totalClosedCases }}</span>
                <span class="text-xs">Expedientes<br>finalizados</span>
            </div>
            <div class="bg-red-100 text-red-800 p-2 flex align-items-center gap-2">
                <span class="font-bold text-xlg">{{ totalCanceledCases }}</span>
                <span class="text-xs">Expedientes<br>anulados</span>
            </div>
            <div class="bg-gray-100 text-gray-800 p-2 flex align-items-center gap-2">
                <span class="font-bold text-xlg">{{ totalActiveCases + totalCanceledCases + totalClosedCases }}</span>
                <span class="text-xs">Expedientes<br>totales</span>
            </div>
        </div>
        <p-table styleClass="mt-4" #grid [value]="costsLinesCases" [lazy]="true" (onLazyLoad)="loadData('case', $event)" [loading]="loading"
            [paginator]="true" [rows]="25" [totalRecords]="totalRecordsCases" [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
            [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th pSortableColumn="date">Fecha <p-sortIcon field="date"></p-sortIcon></th>
                    <th pSortableColumn="case.caseNumber">Expediente <p-sortIcon field="case.caseNumber"></p-sortIcon></th>
                    <th pSortableColumn="case.caseDate">Fecha de expediente <p-sortIcon field="case.caseDate"></p-sortIcon></th>
                    <th pSortableColumn="case.contract.name">Contrato <p-sortIcon field="case.contract.name"></p-sortIcon></th>
                    <th pSortableColumn="case.caseState.name">Estado <p-sortIcon field="case.caseState.name"></p-sortIcon></th>
                    <th pSortableColumn="description">Descripción </th>
                    <th pSortableColumn="price">Precio <p-sortIcon field="price"></p-sortIcon></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-consumption let-columns="columns">
                <tr (dblclick)="edit(consumption)">
                    <td>{{consumption.date | date:'dd/MM/yyyy'}}</td>
                    <td>{{consumption.case?.caseNumber}}</td>
                    <td>{{consumption.case?.caseDate | date:'dd/MM/yyyy'}}</td>
                    <td>{{consumption.case?.contract?.name}}</td>
                    <td>{{consumption.case?.caseState?.name}}</td>
                    <td>{{consumption.description}}</td>
                    <td>{{consumption.price | currency: 'EUR'}}</td>
                </tr>
            </ng-template>
        </p-table>
      </div>
    </p-accordionTab>

    <p-accordionTab >
      <ng-template pTemplate="header">      
        <div class="flex justify-between items-center w-full align-items-center">
            <div class="flex align-items-center gap-2">
                <i class="pi pi-comments"></i>
                <div class="flex flex-column">
                    <span>SMS</span>
                    <small class="text-color-secondary mt-1 font-normal">Coste de los mensajes SMS enviados y recibidos</small>
                </div>
            </div>
            <div class="flex gap-2 ml-auto">
                <p-tag styleClass="tag-gray" value="{{totalRecordsSms}} recuento total"
                [ngClass]="{'flex items-center justify-center text-center': true}"/>    
                <p-tag [severity]="'success'" value="{{totalProfitSms | currency: 'EUR'}} precio total" 
                    [ngClass]="{'flex items-center justify-center text-center': true}"/>  
            </div>                      
        </div>
      </ng-template>
      <div>
        <p-table styleClass="mt-4" #grid [value]="costsLinesSms" [lazy]="true" [loading]="loading"  (onLazyLoad)="loadData('sms', $event)"
            [paginator]="true" [rows]="25" [totalRecords]="totalRecordsSms" [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
            [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th pSortableColumn="date">Fecha <p-sortIcon field="date"></p-sortIcon></th>
                    <th pSortableColumn="description">Descripción </th>
                    <th pSortableColumn="price">Precio <p-sortIcon field="price"></p-sortIcon></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-consumption let-columns="columns">
                <tr (dblclick)="edit(consumption)">
                     <td>{{consumption.date | date:'dd/MM/yyyy HH:mm:ss'}}</td>
                    <td>{{consumption.description}}</td>
                    <td>{{consumption.price | currency: 'EUR' : 'symbol' : '1.5-5'}}</td>
                </tr>
            </ng-template>
        </p-table>
      </div>
    </p-accordionTab>

    <p-accordionTab>
      <ng-template pTemplate="header">      
        <div class="flex justify-between items-center w-full align-items-center">
            <div class="flex align-items-center gap-2">
                <i class="pi pi-map-marker"></i>
                <div class="flex flex-column">
                    <span>Google apis</span>
                    <small class="text-color-secondary mt-1 font-normal">Consumo de las APIs de Google (mapas, geolocalización...)</small>
                </div>
            </div>
            <div class="flex gap-2 ml-auto">
                <p-tag styleClass="tag-gray" value="{{totalRecordsGoogle}} recuento total"
                [ngClass]="{'flex items-center justify-center text-center': true}"/>    
                <p-tag [severity]="'success'" value="{{totalProfitGoogle | currency: 'EUR'}} precio total" 
                    [ngClass]="{'flex items-center justify-center text-center': true}"/>  
            </div>                      
        </div>
      </ng-template>
      <div>
        <p-table styleClass="mt-4" #grid [value]="costsLinesGoogle" [lazy]="true"  [loading]="loading"
            [paginator]="true" [rows]="25" [totalRecords]="totalRecordsGoogle" [showCurrentPageReport]="true" (onLazyLoad)="loadData('google', $event)"
            currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
            [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
            <ng-template pTemplate="header" let-columns>
                <tr>
                   <th pSortableColumn="date">Fecha <p-sortIcon field="date"></p-sortIcon></th>
                    <th pSortableColumn="description">Descripción </th>
                    <th pSortableColumn="price">Precio <p-sortIcon field="price"></p-sortIcon></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-consumption let-columns="columns">
                <tr (dblclick)="edit(consumption)">
                    <td>{{consumption.date | date:'dd/MM/yyyy HH:mm:ss'}}</td>
                    <td>{{consumption.description}}</td>
                    <td>{{consumption.price | currency: 'EUR' : 'symbol' : '1.5-5'}}</td>
                </tr>
            </ng-template>
        </p-table>
      </div>
    </p-accordionTab>

    <p-accordionTab>
      <ng-template pTemplate="header">      
        <div class="flex justify-between items-center w-full align-items-center">
            <div class="flex align-items-center gap-2">
                <i class="pi pi-bolt"></i>
                <div class="flex flex-column">
                    <span>IA Agentes</span>
                    <small class="text-color-secondary mt-1 font-normal">Coste de las interacciones con agentes de inteligencia artificial</small>
                </div>
            </div>
            <div class="flex gap-2 ml-auto">
                <p-tag styleClass="tag-gray" value="{{totalRecordsIA}} recuento total"
                [ngClass]="{'flex items-center justify-center text-center': true}"/>    
                <p-tag [severity]="'success'" value="{{totalProfitIA | currency: 'EUR'}} precio total" 
                    [ngClass]="{'flex items-center justify-center text-center': true}"/>  
            </div>                      
        </div>
      </ng-template>
      <div>
        <div class="flex gap-2 pb-2 mt-4 align-items-center">
            <p-multiSelect [options]="iaAgentTypeOptions" [(ngModel)]="selectedIaAgentTypes"
                optionLabel="label" optionValue="value" placeholder="Todos los tipos de agente"
                selectedItemsLabel="{0} tipos seleccionados" showClear
                (onChange)="onIaAgentTypeChange()" (onClear)="onIaAgentTypeClear()"
                appendTo="body" styleClass="w-20rem"></p-multiSelect>
        </div>
        <p-table styleClass="mt-2" #grid [value]="costsLinesIA" [lazy]="true"  [loading]="loading"
            [paginator]="true" [rows]="25" [totalRecords]="totalRecordsIA" [showCurrentPageReport]="true" (onLazyLoad)="loadData('ia', $event)"
            currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
            [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
            <ng-template pTemplate="header" let-columns>
                <tr>
                   <th pSortableColumn="date">Fecha <p-sortIcon field="date"></p-sortIcon></th>
                    <th pSortableColumn="type">Tipo de agente <p-sortIcon field="type"></p-sortIcon></th>
                    <th pSortableColumn="description">Descripción </th>
                    <th pSortableColumn="price">Precio <p-sortIcon field="price"></p-sortIcon></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-consumption let-columns="columns">
                <tr (dblclick)="edit(consumption)">
                    <td>{{consumption.date | date:'dd/MM/yyyy HH:mm:ss'}}</td>
                    <td>{{getAgentTypeLabel(consumption.type)}}</td>
                    <td>{{consumption.description}}</td>
                    <td>{{consumption.price | currency: 'EUR' : 'symbol' : '1.5-5'}}</td>
                </tr>
            </ng-template>
        </p-table>
      </div>
    </p-accordionTab>

    <p-accordionTab>
      <ng-template pTemplate="header">
        <div class="flex justify-between items-center w-full align-items-center">
            <div class="flex align-items-center gap-2">
                <i class="pi pi-server"></i>
                <div class="flex flex-column">
                    <span>Consumo API</span>
                    <small class="text-color-secondary mt-1 font-normal">Coste de las llamadas a la API de la plataforma</small>
                </div>
            </div>
            <div class="flex gap-2 ml-auto">
                <p-tag styleClass="tag-gray" value="{{totalRecordsApi}} recuento total"
                [ngClass]="{'flex items-center justify-center text-center': true}"/>
                <p-tag [severity]="'success'" value="{{totalProfitApi | currency: 'EUR'}} precio total"
                    [ngClass]="{'flex items-center justify-center text-center': true}"/>
            </div>
        </div>
      </ng-template>
      <div>
        <p-table styleClass="mt-4" #grid [value]="costsLinesApi" [lazy]="true" [loading]="loading"
            [paginator]="true" [rows]="25" [totalRecords]="totalRecordsApi" [showCurrentPageReport]="true" (onLazyLoad)="loadData('api', $event)"
            currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
            [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th pSortableColumn="date">Fecha <p-sortIcon field="date"></p-sortIcon></th>
                    <th pSortableColumn="description">Descripción </th>
                    <th pSortableColumn="price">Precio <p-sortIcon field="price"></p-sortIcon></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-consumption let-columns="columns">
                <tr (dblclick)="edit(consumption)">
                    <td>{{consumption.date | date:'dd/MM/yyyy HH:mm:ss'}}</td>
                    <td>{{consumption.description}}</td>
                    <td>{{consumption.price | currency: 'EUR' : 'symbol' : '1.5-5'}}</td>
                </tr>
            </ng-template>
        </p-table>
      </div>
    </p-accordionTab>

    <p-accordionTab>
      <ng-template pTemplate="header">
        <div class="flex justify-between items-center w-full align-items-center">
            <div class="flex align-items-center gap-2">
                <i class="pi pi-phone"></i>
                <div class="flex flex-column">
                    <span>Centralita</span>
                    <small class="text-color-secondary mt-1 font-normal">Coste de las llamadas telefónicas de la centralita y los DDIs contratados</small>
                </div>
            </div>
            <div class="flex gap-2 ml-auto">
                <p-tag styleClass="tag-gray" value="{{totalRecordsPbx}} recuento total"
                [ngClass]="{'flex items-center justify-center text-center': true}"/>
                <p-tag [severity]="'success'" value="{{totalProfitPbx | currency: 'EUR'}} precio total"
                    [ngClass]="{'flex items-center justify-center text-center': true}"/>
            </div>
        </div>
      </ng-template>
      <div>
        <p-table styleClass="mt-4" #grid [value]="costsLinesPbx" [lazy]="true" [loading]="loading"
            [paginator]="true" [rows]="25" [totalRecords]="totalRecordsPbx" [showCurrentPageReport]="true" (onLazyLoad)="loadData('pbx', $event)"
            currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
            [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th pSortableColumn="date">Fecha <p-sortIcon field="date"></p-sortIcon></th>
                    <th pSortableColumn="description">Descripción </th>
                    <th pSortableColumn="price">Precio <p-sortIcon field="price"></p-sortIcon></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-consumption let-columns="columns">
                <tr (dblclick)="edit(consumption)">
                    <td>{{consumption.date | date:'dd/MM/yyyy HH:mm:ss'}}</td>
                    <td>{{consumption.description}}</td>
                    <td>{{consumption.price | currency: 'EUR' : 'symbol' : '1.5-5'}}</td>
                </tr>
            </ng-template>
        </p-table>
      </div>
    </p-accordionTab>

    <p-accordionTab >
      <ng-template pTemplate="header">
        <div class="flex justify-between items-center w-full align-items-center">
            <div class="flex align-items-center gap-2">
                <i class="pi pi-whatsapp"></i>
                <div class="flex flex-column">
                    <span>WhatsApp por META</span>
                    <small class="text-color-secondary mt-1 font-normal">Coste de los mensajes de WhatsApp a través de META</small>
                </div>
            </div>
            <div class="flex gap-2 ml-auto">
                <p-tag styleClass="tag-gray" value="{{totalRecordsWhatsapp}} recuento total"
                [ngClass]="{'flex items-center justify-center text-center': true}"/>    
                <p-tag [severity]="'success'" value="{{totalProfitWhatsapp | currency: 'EUR'}} precio total" 
                    [ngClass]="{'flex items-center justify-center text-center': true}"/>  
            </div>                      
        </div>
      </ng-template>
      <div>
        <p-table styleClass="mt-4" #grid [value]="costsLinesWhatsapp" [lazy]="true" [loading]="loading"  (onLazyLoad)="loadData('whatsapp', $event)"
            [paginator]="true" [rows]="25" [totalRecords]="totalRecordsWhatsapp" [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
            [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th pSortableColumn="date">Fecha <p-sortIcon field="date"></p-sortIcon></th>
                    <th pSortableColumn="description">Descripción </th>
                    <th pSortableColumn="price">Precio <p-sortIcon field="price"></p-sortIcon></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-consumption let-columns="columns">
                <tr (dblclick)="edit(consumption)">
                     <td>{{consumption.date | date:'dd/MM/yyyy HH:mm:ss'}}</td>
                    <td>{{consumption.description}}</td>
                    <td>{{consumption.price | currency: 'EUR' : 'symbol' : '1.5-5'}}</td>
                </tr>
            </ng-template>
        </p-table>
      </div>
    </p-accordionTab>

  </p-accordion>
  

  <div class="p-mt-4 flex flex-column align-items-end">
    <h3>Subtotal: {{ subtotal | currency: 'EUR' }}</h3>
    <h3>Impuestos (21%): {{ tax | currency: 'EUR' }}</h3>
    <h2>Total: {{ total | currency: 'EUR' }}</h2>
  </div>

<p-confirmDialog></p-confirmDialog>